export default __webpack_public_path__ + "static/media/map.88cb7bd6.mp4";